(function() {
  'use strict';

  const API_URL    = 'https://apps.gemstonesforsale.com/wp-json/shopify/v1/storeCollections';
  const STORE_URL  = 'https://www.gemstonesforsale.com';
  const CONTAINER  = document.getElementById('shopify-collections-directory');
  const CACHE_KEY  = 'shopify_collections_cache';
  const CACHE_TIME = 6 * 60 * 60 * 1000; // 6 hours in milliseconds

  // Collections to skip (system/app collections that shouldn't show publicly)
  const EXCLUDE_HANDLES = [
    'cloud-search-all-products'
  ];

  /**
   * Convert "ABALONE SHELL" / "abalone-shell" → "Abalone Shell"
   */
  function toTitleCase(str) {
    return str
      .toLowerCase()
      .replace(/[-_]/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase())
      .trim();
  }

  /**
   * Get the first character for grouping.
   * Numbers stay as-is, letters get uppercased, symbols → "#"
   */
  function getGroupKey(title) {
    const first = title.trim().charAt(0).toUpperCase();
    if (/[A-Z]/.test(first)) return first;
    if (/[0-9]/.test(first)) return first;
    return '#';
  }

  /**
   */
  function cleanDisplayTitle(title) {
    return toTitleCase(title);
  }

  /**
   * Fetch collections — try cache first, fall back to API
   */
  async function fetchCollections() {
    // Check localStorage cache
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        if (Date.now() - parsed.timestamp < CACHE_TIME) {
          return parsed.data;
        }
      }
    } catch (e) {
      // localStorage unavailable or corrupt — proceed to fetch
    }

    const response = await fetch(API_URL);
    if (!response.ok) {
      throw new Error('Network error: ' + response.status);
    }

    const json = await response.json();
    if (!json.success || !Array.isArray(json.data)) {
      throw new Error('Invalid API response');
    }

    // Save to cache
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        timestamp: Date.now(),
        data: json.data
      }));
    } catch (e) {
      // Storage full or disabled — ignore
    }

    return json.data;
  }

  /**
   * Group collections alphabetically: numbers first, then A-Z, then symbols
   */
  function groupCollections(collections) {
    const groups = {};

    collections.forEach(col => {
      if (EXCLUDE_HANDLES.includes(col.handle)) return;

      const key = getGroupKey(col.title);
      if (!groups[key]) groups[key] = [];
      groups[key].push(col);
    });

    // Sort each group alphabetically
    Object.keys(groups).forEach(key => {
      groups[key].sort((a, b) => a.title.localeCompare(b.title, 'en', { sensitivity: 'base' }));
    });

    return groups;
  }

  /**
   * Build the HTML structure matching the existing directory layout
   */
  function renderDirectory(groups) {
    // Custom sort order: numbers 0-9 first, then A-Z, then "#" for symbols
    const sortedKeys = Object.keys(groups).sort((a, b) => {
      const aIsNum = /[0-9]/.test(a);
      const bIsNum = /[0-9]/.test(b);
      if (aIsNum && !bIsNum) return -1;
      if (!aIsNum && bIsNum) return 1;
      if (a === '#') return 1;
      if (b === '#') return -1;
      return a.localeCompare(b);
    });

    let html = '';

    sortedKeys.forEach(letter => {
      html += `<h3 id="collections-${letter}" class="letter-heading">${letter}</h3>`;
      html += '<ul class="link-grid">';

      groups[letter].forEach(col => {
        const displayTitle = cleanDisplayTitle(col.title);
        const url = `${STORE_URL}/collections/${col.handle}`;
        html += `<li><a href="${url}">${displayTitle}</a></li>`;
      });

      html += '</ul>';
    });

    CONTAINER.innerHTML = html;
  }

  /**
   * Init
   */
  async function init() {
    try {
      const collections = await fetchCollections();
      const groups = groupCollections(collections);
      renderDirectory(groups);
    } catch (err) {
      console.error('Collections load failed:', err);
      CONTAINER.innerHTML = '<div class="collections-error">Unable to load collections. Please refresh the page.</div>';
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  function scrollToCenter(target) {
    const rect = target.getBoundingClientRect();
    const targetTop = rect.top + window.pageYOffset;
    const offset = targetTop - (window.innerHeight / 2) + (rect.height / 2);

    window.scrollTo({
      top: offset,
      behavior: 'smooth'
    });
  }

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href*="#"]');
    if (!link) return;

    const href = link.getAttribute('href');
    // only handle in-page anchors (#A, #gems) or same-page anchors (/page#gems)
    const hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;

    const hash = href.substring(hashIndex);
    if (hash === '#' || hash.length < 2) return;

    // ensure it's the same page (or pure hash link)
    const linkPath = href.substring(0, hashIndex);
    if (linkPath && linkPath !== window.location.pathname && !href.startsWith('#')) return;

    const target = document.querySelector(hash);
    if (!target) return;

    e.preventDefault();
    scrollToCenter(target);

    // update URL without jumping
    history.pushState(null, '', hash);
  });

  // handle direct page loads with a hash (e.g. someone lands on yoursite.com/page#gems)
  window.addEventListener('load', function () {
    if (window.location.hash) {
      const target = document.querySelector(window.location.hash);
      if (target) {
        setTimeout(function () {
          scrollToCenter(target);
        }, 100);
      }
    }
  });
})();